<template lang="pug">
div(v-if="feature")
    h3 Selected site
    p Team {{ p.team}}
    h3 Predicted mineral presence
    table

        tr(v-for="mineral of minerals").gc-orange
            th {{ mineral.name }}
        tr(v-if="!minerals.length")
            th {{ p.commodity || Unknown }}
    div(v-if="Object.keys(extraAttributes).length")
        h3 Other attributes
        table#FeatureInfo(v-if="feature").white.ma1
            tr(v-for="([prop, value]) in extraAttributes")
                template(v-if="ignoreProps.indexOf(prop) === -1")
                    th.f6 {{ prop }}
                    td.f6 {{ typeof value === 'number' ? Math.round(value * 1000) / 1000 : value }}
</template>

<script>
import { EventBus } from '../EventBus';
export default {
    name: 'FeatureInfo',
    data: () => ({
        feature: undefined,
        ignoreProps: ['id', 'Longitude', 'Latitude', 'image_url']
    }),
    computed: {
        p() {
            return this.feature && this.feature.properties;
        },
        pp() {
            return this.p || {};
        },
        imageUrl() {
            return this.p && this.p.image_url;
        },
        extraAttributes() {
            return Object.keys(this.pp)
                .filter(
                    key =>
                        !window.app.App.minerals[key] &&
                        !['team' /* 'commodity'*/].includes(key) &&
                        !(key.length <= 2 && !this.pp[key])
                )
                .map(key => [key, this.pp[key]]);
        },
        minerals() {
            return Object.keys(window.app.App.minerals)
                .filter(
                    mineralId =>
                        this.pp[mineralId] ||
                        (this.pp.commodity || '').match(
                            `\\b${mineralId}\\d*\\b`
                        )
                )
                .map(mineralId => ({
                    id: mineralId,
                    name: window.app.App.minerals[mineralId].name,
                    color: window.app.App.minerals[mineralId].color
                }));
        }
    },
    created() {
        window.app.FeatureInfo = this;
        EventBus.$on('select-feature', feature => (this.feature = feature));
    }
};
</script>

<style scoped>
#FeatureInfo th {
    /* text-align: right; */
    text-align: left;
}
th {
    color: hsl(24, 100%, 50%);
    font-weight: normal;
}
.image {
    width: 100%;
}

td {
    overflow-wrap: anywhere;
}
li {
    list-style: none;
}

th {
    text-align: left;
}
</style>
